<div class="exception-body">
    <div class="exception-topbar">
        <a href="#" class="logo">
            <img src="assets/layout/images/logo.png" alt="california-layout"/>
        </a>
    </div>

    <img class="exception-image" src="assets/layout/images/image-404.png" alt="california-layout" />

    <div class="exception-panel">
        <img class="exception-icon" src="assets/layout/images/icon-404.png" alt="california-layout" />
        <h1 class="exception-summary">Página no encontrada</h1>
        <p class="exception-detail">
            Esta página no está disponible.<br>
        </p>
        <div>
            <button type="button" pButton label="Ir al inicio" [routerLink]="['/']"></button>
        </div>
    </div>
</div>
